export const isNavigableCrefoId = (memberId) =>
  !!memberId && /^\d+$/.test(String(memberId));

/**
 * The individual-profile id of a key contact, or null when it has none.
 * Contacts carry the CREFO person id as `person_crefo_id` (the `company_managers`
 * view has not exposed `member_id` since 2026-05); discovered contacts hold a
 * non-numeric `disc_<uuid>` there and so have no profile.
 * @param {{ person_crefo_id?: string|number }} [contact]
 * @returns {string|null}
 */
export const getContactIndividualId = (contact) =>
  isNavigableCrefoId(contact?.person_crefo_id) ? String(contact.person_crefo_id) : null;
